export default "__VITE_ASSET__Dddq8FKr__"